import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UserTabsComponent } from './pages/user-tabs/user-tabs.component';
import { BrowserSpecialGuard } from '../../shared/guards/browser-special.guard';

const routes: Routes = [
    {
        path: '',
        component: UserTabsComponent,
        children: [
            {
                path: 'details',
                canActivate: [BrowserSpecialGuard],
                loadChildren: () =>
                    import('../../modules/clinic/clinic.module').then(
                        (m) => m.ClinicModule
                    ),
            },
            {
                path: 'user-account',
                loadChildren: () =>
                    import(
                        '../../modules/user-account/user-account.module'
                    ).then((m) => m.UserAccountModule),
            },
            {
                path: 'treatment',
                loadChildren: () =>
                    import('../../modules/treatment/treatment.module').then(
                        (m) => m.TreatmentModule
                    ),
            },
            {
                path: 'appointment',
                loadChildren: () =>
                    import('../../modules/appointment/appointment.module').then(
                        (m) => m.AppointmentModule
                    ),
            },
            {
                path: 'message',
                loadChildren: () =>
                    import('../messages/message.module').then(
                        (m) => m.MessageModule
                    ),
            },
            {
                path: 'friend-program',
                loadChildren: () =>
                    import('../friend-program/friend-program.module').then(
                        (m) => m.FriendProgramModule
                    ),
            },
        ],
    },
    {
        path: 'register',
        loadChildren: () =>
            import('../../modules/register/register.module').then(
                (m) => m.RegisterModule
            ),
    },
    {
        path: 'user-account-edit',
        loadChildren: () =>
            import(
                '../../modules/user-account-edit/user-account-edit.module'
            ).then((m) => m.UserAccountEditModule),
    },
    {
        path: 'message-detail/:messageId',
        loadChildren: () =>
            import('../../modules/message-detail/message-detail.module').then(
                (m) => m.MessageDetailModule
            ),
    },
    {
        path: '**',
        loadChildren: () =>
            import('../not-found/not-found.module').then(
                (m) => m.NotFoundModule
            ),
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class UserTabsRoutingModule {}
